import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Typography,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const DMCPopupTable = ({ data, setDMCPopupOpen }) => {
  const originalData = data?.['regional team votes'];
  const regionMap = {};
  originalData?.forEach((entry) => {
    const [fullKey, value] = Object.entries(entry)[0];
    const regionName = fullKey.match(/^(.*?)(?= agree| recommendation| comments)/)?.[0];

    if (!regionName) return;

    if (!regionMap[regionName]) {
      regionMap[regionName] = {
        region: regionName,
        agree: '',
        recommendation: '',
        comments: ''
      };
    }

    if (fullKey.includes('agree')) regionMap[regionName].agree = value;
    if (fullKey.includes('recommendation')) regionMap[regionName].recommendation = value || '';
    if (fullKey.includes('comments')) regionMap[regionName].comments = value || '';
  });

  const formattedData = Object.values(regionMap);

  const getAgreeColor = (value) => {
    return value === true ? '#CCE7DD' : value === false ? '#F6CCD2' : '';
  };
  return (
    <Dialog open={true} onClose={() => setDMCPopupOpen(false)} maxWidth="xl" fullWidth>
      <DialogTitle>
        <Typography variant="h6">Inputs from Regional Teams</Typography>
        <Typography variant="subtitle2">
          Steering Team Recommendation: {data?.['steering team recommendation']}
        </Typography>
        <IconButton
          onClick={() => setDMCPopupOpen(false)}
          sx={{ position: 'absolute', top: 8, right: 8 }}
          aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Table
          sx={{
            border: '1px solid #D7E5F8',
            borderCollapse: 'collapse'
          }}>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  border: '1px solid #D7E5F8' // Border for the first column
                }}
              />
              {formattedData.map((item) => (
                <TableCell
                  key={item.region}
                  align="center"
                  sx={{
                    fontWeight: 'bold'
                  }}>
                  {item.region.toUpperCase()}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell
                sx={{
                  border: '1px solid #D7E5F8' // Border for the first column
                }}>
                Agree with Steering Reco
              </TableCell>
              {formattedData.map((item, index) => (
                <TableCell
                  key={`${index + 1}`}
                  align="center"
                  sx={{
                    backgroundColor: getAgreeColor(item.agree)
                  }}>
                  {item.agree === true ? 'Agree' : item.agree === false ? 'Disagree' : ''}
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              <TableCell
                sx={{
                  border: '1px solid #D7E5F8' // Border for the first column
                }}>
                Recommendation
              </TableCell>
              {formattedData.map((item, index) => (
                <TableCell key={`${index + 1}`} align="center">
                  {item.recommendation}
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              <TableCell
                sx={{
                  border: '1px solid #D7E5F8' // Border for the first column
                }}>
                Comments
              </TableCell>
              {formattedData.map((item, index) => (
                <TableCell key={`${index + 1}`}  align="center">
                  <Box sx={{ maxHeight: 100, overflow: 'auto' }}>{item.comments}</Box>
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};

export default DMCPopupTable;
